import React, { ChangeEvent, useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { Body2, Heading3 } from '@/components/ui/typography'
import { AuthorisedTrader } from 'api/Clients/Types/ClientDetailedDto'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchCountriesAction } from 'store/identity/identity.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { IdentityApiClient } from 'utils/api/identityApi'
import { isEmpty } from 'utils/is-empty'

import styles from './ClientDetailsCorporateForm.module.scss'

interface OuterProps {
  data: AuthorisedTrader

  onChange(values: Partial<AuthorisedTrader>): void
}

export const AuthorisedTraderForm: React.FC<OuterProps> = ({ onChange, data }) => {
  const [form, setForm] = useState<Partial<AuthorisedTrader>>({
    id: data?.id,
    name: data.name,
    role: data.role,
    email: data.email,
  })
  const [error, setErrors] = useState<string>()

  const identityApiClient = useApiClient(IdentityApiClient)

  const countries = useAppSelector((state) => state.identity.countries)

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (isEmpty(countries)) {
      dispatch(fetchCountriesAction(identityApiClient))
    }
  }, [dispatch, countries]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [event.target.name]: event.target.value })
  }

  const handleSubmitForm = () => {
    validateForm()

    if (isValidForm()) {
      onChange(form)
    }
  }

  const validateForm = () => {
    if (!isValidForm()) {
      setErrors('Please fill required fields!')
    } else {
      setErrors(undefined)
    }
  }

  const isValidForm = () => {
    return Object.values(form).every((value) => {
      return !!value
    })
  }

  return (
    <div className={styles.container}>
      <div>
        <Heading3 className={styles.title}>Authorised Trader</Heading3>
      </div>

      <div className={styles.field}>
        <Body2 as='label' bold>
          Name<span>*</span>
        </Body2>
        <div className={styles.input}>
          <input name='name' value={form.name} type='text' required onChange={handleChange} />
        </div>
      </div>

      <div className={styles.field}>
        <Body2 as='label' bold>
          Role in Company<span>*</span>
        </Body2>
        <div className={styles.input}>
          <input name='role' value={form.role} type='text' required onChange={handleChange} />
        </div>
      </div>

      <div className={styles.field}>
        <Body2 as='label' bold>
          Email<span>*</span>
        </Body2>
        <div className={styles.input}>
          <input name='email' value={form.email} type='text' required onChange={handleChange} />
        </div>
      </div>

      <div className={styles.submit}>
        <Button type='button' onClick={handleSubmitForm}>
          Save
        </Button>
        {error && <div className={styles.error}>{error}</div>}
      </div>
    </div>
  )
}
